import {Repository, createRepository} from '@/repositories/Base/Repository'

class CoreCompaniesRepository extends Repository {
    endpoint = 'companies'

    fetchAllPaginated(params) {
        return this.$axios.get(`${this.endpoint}/index/paginated`, {params})
    }

    fetchAllInVs(params) {
        return this.$axios.get(`${this.endpoint}/in-vs`, {params})
    }

    fetchInVs(id) {
        return this.$axios.get(`${this.endpoint}/in-vs/${id}`)
    }
}

export default new CoreCompaniesRepository()

export const create = createRepository(CoreCompaniesRepository)
